module.exports = __webpack_public_path__ + "static/img/20bosChart.8e650c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/20bosChart.png
// module id = 7DFZ
// module chunks = 1